export class LastCallStruct {
    public lastCallOximeter: Date | null = null;
    public lastCallGlucometer: Date | null = null;
    public lastCallThermometer: Date | null = null;
    public lastCallBloodPressure: Date | null = null;
}